// The semi-colon before the function invocation is a safety 
// net against concatenated scripts and/or other plugins 
// that are not closed properly.
; (function ($, window, document, undefined) {

	// undefined is used here as the undefined global 
	// variable in ECMAScript 3 and is mutable (i.e. it can 
	// be changed by someone else). undefined isn't really 
	// being passed in so we can ensure that its value is 
	// truly undefined. In ES5, undefined can no longer be 
	// modified.

	// window and document are passed through as local 
	// variables rather than as globals, because this (slightly) 
	// quickens the resolution process and can be more 
	// efficiently minified (especially when both are 
	// regularly referenced in your plugin).

	// Create the defaults once
	var pluginName = 'tagfilter';
	var defaults = {};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.element = element;
		this.$element = $(element);

		this.options = $.extend({}, defaults, options);

		this._defaults = defaults;
		this._name = pluginName;

		this.init();
	}

	Plugin.prototype.init = function () {

		var $base = this;

		$base.$element.on('click', 'a', function (e) {
			var hash = $(this).attr('href');
			if ($(this).hasClass('active')) {
				e.preventDefault();
				history.pushState("", document.title, window.location.pathname);
				hash = null;
			}

			$base.filterList(hash);
		});

		$base.filterList();
	};

	Plugin.prototype.filterList = function (hash) {

		var $base = this;

		if (!hash) {
			hash = window.location.hash;
		}

		// Filter and set active
		$('a', $base.$element).removeClass('active');
		$('a[href="' + hash + '"]', $base.$element).addClass('active');

		var $listWrapper = $base.$element.siblings('.row');

		if (!hash) {
			$('*[data-tags]', $listWrapper).removeClass('hidden');
			return;
		}

		// Filter
		$('*[data-tags]', $listWrapper).addClass('hidden');
		$('*[data-tags*="' + hash.replace('#', '') + '"]', $listWrapper).removeClass('hidden');
	};

	// A really lightweight plugin wrapper around the constructor, 
	// preventing against multiple instantiations
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, pluginName)) {
				$.data(this, pluginName, new Plugin(this, options));
			}
		});
	};
})(jQuery, window, document);